import type { RefObject } from 'react';
import { findTransitionController } from '../../../util/core-transition-component';
import { fadeFromTo, fadeTo } from '../../../util/animation/fade/fade';

interface SiteHeaderRefs {
  elementRef: RefObject<HTMLElement | null>;
  navigationListRef: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, navigationListRef }: SiteHeaderRefs,
): void {
  const navigationController = findTransitionController(navigationListRef);
  timeline.add(fadeFromTo(elementRef.current as HTMLElement, { autoAlpha: true }), 0);
  timeline.add(navigationController?.getTimeline('in') as gsap.core.Timeline, 0);
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: SiteHeaderRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement, { autoAlpha: true }), 0);
}
